import flatten from "@turf/flatten";
import { along, center, length } from "@turf/turf";
import { Feature, FeatureCollection, Geometry, Point } from "geojson";

export const buildStyleFeatures = async (fc: FeatureCollection) => {
    const flat = flatten(fc as any) as FeatureCollection<Geometry>;

    const result: Feature<Point>[] = [];
    for (const f of flat.features) {
        switch (f.geometry.type) {
            case 'LineString': {
                const lineLength = length(f, { units: 'meters' });
                const lineAlong = along(f.geometry, lineLength / 2, { units: 'meters' });
                result.push({
                    ...f,
                    geometry: lineAlong.geometry
                });
                break;
            }
            case 'Polygon': {
                const centerPoint = center(f.geometry);
                result.push({
                    ...f,
                    geometry: centerPoint.geometry
                });
                break;
            }
            case 'Point': {
                result.push(f as Feature<Point>);
                break;
            }
        }
    }
    return result;
};